import { render, staticRenderFns } from "./InformesMenu.vue?vue&type=template&id=8453edb4&scoped=true&"
import script from "./InformesMenu.vue?vue&type=script&lang=ts&"
export * from "./InformesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./InformesMenu.vue?vue&type=style&index=0&id=8453edb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8453edb4",
  null
  
)

export default component.exports